import { OnInit, EventEmitter, OnDestroy, ElementRef } from '@angular/core';
import { SummaryService } from '../services/summary.service';
import { debounceTime, tap, switchMap, distinctUntilChanged, filter } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material';
var PropertySummaryComponent = /** @class */ (function () {
    function PropertySummaryComponent(summaryService) {
        this.summaryService = summaryService;
        this.propertySuggest = new EventEmitter();
        this.formControl = new FormControl();
        this.selectedData = [];
        this.separatorKeysCodes = []; // to disable the enter key in input
        this.nextDataLength = 0;
        this.searchTextChanged = new Subject();
    }
    Object.defineProperty(PropertySummaryComponent.prototype, "suggestSummary", {
        set: function (property) {
            var _this = this;
            // ex: type|summaryName
            this.isBusy = true;
            this.summaryService.getBasicSummary(property.PropertyDisplayFormat.split('|')[0], property.PropertyDisplayFormat.split('|')[1]).subscribe(function (result) {
                if (result) {
                    _this.componentId = result;
                    _this.isPropertySummary = true;
                    _this.propertySummary = property;
                }
                _this.isBusy = false;
            }, function (error) {
                _this.isBusy = false;
            });
        },
        enumerable: true,
        configurable: true
    });
    PropertySummaryComponent.prototype.ngOnInit = function () {
        // for reactive form
        // this.formControl.valueChanges
        // .pipe(
        //   debounceTime(300),
        //   tap((value) => {
        //     typeof value == "object" ? this.propertySuggest.emit(value[this.retrieveFilteredData('ID')]) : this.propertySuggest.emit(value);
        //     this.isPropertyLoading = true
        //   }
        //   ),
        //   switchMap(value => this.summaryService.searchAndReturnSummary(this.componentId, typeof value == "object" ? value[this.retrieveFilteredData('prop1')] : value).pipe(
        //     finalize(() => {
        //       this.isPropertyLoading = false
        //     }),
        //     )
        //   )
        // ).subscribe(result => {
        //   this.summary = JSON.parse(result);
        //   console.log(this.summary);
        var _this = this;
        //   const filteredSummary = this.summary;
        //   this.imageObject = [];
        //   this.imageId = [];
        //   filteredSummary.Data.forEach(element => {
        //     // set the id
        //     if (element[this.retrieveFilteredData('Image')] != null)
        //     {
        //       let docId = element[this.retrieveFilteredData('ID')];
        //       let array = element[this.retrieveFilteredData('Image')].split(",");
        //       array.forEach(imageId => {
        //         if (!imageId){
        //           imageId = '00000000-0000-0000-0000-000000000000';
        //         }
        //         this.imageId.push(imageId);
        //         this.imageObject.push({docId, imageId});
        //       });
        //     }
        //   });
        //   this.getAllImage(true);
        // })
        // for template driven form
        this.subscription = this.searchTextChanged.pipe(debounceTime(500), distinctUntilChanged(), filter(function (x) { return x != null; }), tap(function (value) {
            _this.handleEmitValue(value);
            _this.isPropertyLoading = true;
        }), switchMap(function (value) { return _this.summaryService.searchAndReturnSummary(_this.componentId, typeof value == "object" ? value[_this.retrieveFilteredData('prop1')] : value.trim()); })).subscribe(function (result) {
            _this.isPropertyLoading = false;
            _this.summary = JSON.parse(result);
            _this.summaryLayout = _this.summary.CardLayoutProperties[0].LayoutType.toUpperCase();
            var filteredSummary = _this.summary;
            _this.imageObject = [];
            _this.imageId = [];
            filteredSummary.Data.forEach(function (element) {
                // set the id
                if (element[_this.retrieveFilteredData('Image')] != null) {
                    var docId_1 = element[_this.retrieveFilteredData('ID')];
                    var array = element[_this.retrieveFilteredData('Image')].split(",");
                    array.forEach(function (imageId) {
                        if (!imageId) {
                            imageId = '00000000-0000-0000-0000-000000000000';
                        }
                        _this.imageId.push(imageId);
                        _this.imageObject.push({ docId: docId_1, imageId: imageId });
                    });
                }
            });
            _this.getAllImage();
        });
    };
    PropertySummaryComponent.prototype.sortSummaryData = function (summary) {
        return summary.Data.sort(function (a, b) {
            if (parseInt(a["#RowNumber"]) > parseInt(b["#RowNumber"])) {
                return 1;
            }
            else if (parseInt(a["#RowNumber"]) < parseInt(b["#RowNumber"])) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    PropertySummaryComponent.prototype.handleEmitValue = function (value) {
        if (value) {
            this.chipList.errorState = false;
        }
        else {
            this.selectedData.length == 0 ? this.chipList.errorState = true : this.chipList.errorState = false;
        }
        if (!this.chipList.errorState) {
            if (this.selectedData.length == 0) {
                this.propertySuggest.emit(value.trim());
            }
        }
    };
    PropertySummaryComponent.prototype.onValueChange = function ($event) {
        if (typeof $event == "object") {
            this.propertySuggest.emit($event[this.retrieveFilteredData('ID')]);
        }
        else {
            this.searchTextChanged.next($event);
        }
    };
    PropertySummaryComponent.prototype.displayFn = function (data) {
        return data ? data[this.retrieveFilteredData('prop1')] : undefined;
    };
    PropertySummaryComponent.prototype.retrieveFilteredData = function (cardProperty) {
        if (this.summary != null) {
            if (this.summary.CardLayoutProperties.find(function (x) { return x.CardProperty == cardProperty; }) != null) {
                return this.summary.CardLayoutProperties.find(function (x) { return x.CardProperty == cardProperty; }).PropertyName;
            }
        }
    };
    PropertySummaryComponent.prototype.getAllImage = function (scrollToTop) {
        var _this = this;
        if (scrollToTop === void 0) { scrollToTop = false; }
        if (this.imageObject) {
            if (this.imageId.length > 0) {
                this.isImageLoad = true;
                this.promiseImage(this.imageId).then(function (chunk) {
                    _this.currentCardImage = chunk;
                    _this.summary.CardImageList = chunk;
                    if (scrollToTop) {
                        setTimeout(function () {
                            _this.autoCompleteRef._setScrollTop((_this.summary.Data.length - _this.nextDataLength) * 75);
                        });
                    }
                });
            }
        }
    };
    PropertySummaryComponent.prototype.promiseImage = function (imageIds) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var list = [];
            _this.summaryService.getAllImage(_this.imageId).subscribe(function (results) {
                var index = 0;
                var _loop_1 = function (result) {
                    result = new Blob([result], { type: 'image/jpg' });
                    var docId = _this.imageObject.find(function (x) { return x.imageId == _this.imageId[index]; }).docId;
                    var reader = new FileReader();
                    reader.addEventListener("load", function () {
                        list.push({
                            DocumentId: docId,
                            ImageId: _this.imageId[index],
                            Blob: reader.result
                        });
                    }, false);
                    if (result) {
                        reader.readAsDataURL(result);
                    }
                    index++;
                };
                for (var _i = 0, results_1 = results; _i < results_1.length; _i++) {
                    var result = results_1[_i];
                    _loop_1(result);
                }
                setTimeout(function () {
                    _this.isImageLoad = false;
                }, 100);
            });
            resolve(list);
        });
    };
    PropertySummaryComponent.prototype.getImageFilteredSummary = function (id) {
        if (this.summary.CardImageList != null) {
            if (this.summary.CardImageList.find(function (x) { return x.DocumentId == id; }) != null) {
                if (this.summary.CardImageList.find(function (x) { return x.DocumentId == id; }).Blob) {
                    return this.summary.CardImageList.find(function (x) { return x.DocumentId == id; }).Blob;
                }
                else {
                    return null;
                }
            }
        }
    };
    PropertySummaryComponent.prototype.onSelectionChanged = function ($event) {
        if ($event.option.value) {
            this.selectedData = [];
            this.selectedData.push($event.option.value);
            this.propertySummary.PropertyValue = $event.option.value[this.retrieveFilteredData('prop1')];
            this.textInput.nativeElement.value = '';
            this.chipList.errorState = false;
        }
    };
    PropertySummaryComponent.prototype.onLoadMore = function ($event) {
        var _this = this;
        $event.stopPropagation();
        if (!this.isFetching) {
            this.isFetching = true;
            this.fetchNextChunk().then(function (chunk) {
                _this.isFetching = false;
                _this.nextDataLength = chunk.Data.length - _this.summary.Data.length;
                _this.summary = chunk;
                _this.loadMoreImages();
            });
        }
    };
    PropertySummaryComponent.prototype.fetchNextChunk = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.summaryService.nextPage(_this.componentId).subscribe(function (result) {
                if (result == "1") {
                    _this.summaryService.getSummary(_this.componentId).subscribe(function (result) {
                        _this.summary.CurrentPage = _this.summary.CurrentPage + 1;
                        var summary = JSON.parse(result);
                        summary = _this.handleNewSummary(summary);
                        resolve(summary);
                    });
                }
            });
        });
    };
    PropertySummaryComponent.prototype.handleNewSummary = function (summary) {
        var _this = this;
        if (summary.Data.length > 0) {
            this.nextImageObject = [];
            this.nextImageId = [];
            summary.Data.forEach(function (element) {
                // set the id
                if (element[_this.retrieveFilteredData('Image')] != null) {
                    var docId_2 = element[_this.retrieveFilteredData('ID')];
                    var array = element[_this.retrieveFilteredData('Image')].split(",");
                    array.forEach(function (imageId) {
                        if (!imageId) {
                            imageId = '00000000-0000-0000-0000-000000000000';
                        }
                        if (_this.imageId.indexOf(imageId) > -1) {
                            _this.imageId.push(imageId);
                            _this.imageObject.push({ docId: docId_2, imageId: imageId });
                        }
                        else {
                            _this.nextImageId.push(imageId);
                            _this.nextImageObject.push({ docId: docId_2, imageId: imageId });
                        }
                    });
                }
            });
        }
        summary.Data = this.sortSummaryData(summary);
        return summary;
    };
    // performance experimental fix
    PropertySummaryComponent.prototype.loadMoreImages = function () {
        var _this = this;
        if (this.nextImageObject) {
            if (this.nextImageId.length > 0) {
                this.isImageLoad = true;
                this.promiseNextImage(this.nextImageId, this.nextImageObject).then(function (chunk) {
                    _this.summary.CardImageList = chunk;
                    setTimeout(function () {
                        _this.autoCompleteRef._setScrollTop((_this.summary.Data.length - _this.nextDataLength - 1) * 75);
                    });
                });
            }
        }
    };
    PropertySummaryComponent.prototype.promiseNextImage = function (imageIds, imageObject) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var list = _this.currentCardImage;
            _this.summaryService.getAllImage(imageIds).subscribe(function (results) {
                var index = 0;
                var _loop_2 = function (result) {
                    result = new Blob([result], { type: 'image/jpg' });
                    var docId = imageObject.find(function (x) { return x.imageId == imageIds[index]; }).docId;
                    var reader = new FileReader();
                    reader.addEventListener("load", function () {
                        list.push({
                            DocumentId: docId,
                            ImageId: imageIds[index],
                            Blob: reader.result
                        });
                    }, false);
                    if (result) {
                        reader.readAsDataURL(result);
                    }
                    index++;
                };
                for (var _i = 0, results_2 = results; _i < results_2.length; _i++) {
                    var result = results_2[_i];
                    _loop_2(result);
                }
            });
            resolve(list);
        });
    };
    // add(event: MatChipInputEvent): void {
    //   // Add data only when MatAutocomplete is not open
    //   // To make sure this does not conflict with OptionSelected Event
    //   if (!this.matAutocomplete.isOpen) {
    //     const input = event.input;
    //     const value = event.value;
    //     // Add selected data
    //     if ((value || '').trim()) {
    //       this.selectedData.push(value.trim());
    //     }
    //     // Reset the input value
    //     if (input) {
    //       input.value = '';
    //     }
    //   }
    // }
    PropertySummaryComponent.prototype.remove = function (data) {
        this.selectedData.forEach(function (element) {
            if (element) {
            }
        });
        this.selectedData = [];
        if (this.textInput.nativeElement.value) {
            this.propertySuggest.emit(this.propertySummary.PropertyValue);
        }
        else {
            this.propertySummary.PropertyValue = '';
        }
        this.textInput.nativeElement.focus();
        if (this.matAutocomplete) {
            this.matAutocomplete.closePanel();
        }
    };
    PropertySummaryComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return PropertySummaryComponent;
}());
export { PropertySummaryComponent };
